import React, { createContext, useContext } from 'react';

interface IdentityContextType {
  isLoggedIn: boolean;
  isLoading: boolean;
  signOut: () => void;
}

const IdentityContext = createContext<IdentityContextType>({
  isLoggedIn: true,
  isLoading: false,
  signOut: () => {},
});

export const IdentityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <IdentityContext.Provider value={{
      isLoggedIn: true,
      isLoading: false,
      signOut: () => {},
    }}>
      {children}
    </IdentityContext.Provider>
  );
};

export const useIdentityContext = () => useContext(IdentityContext);
